import { Box, Separator, Skeleton, SkeletonGroup, TabsStripSkeleton } from "@salestrak/ui";

/**
 * An entity shell (a team, a workflow) before its row has hydrated: the
 * masthead's 28px first line with an identity tile and a name-length bar, the
 * 40px view strip as three tab stand-ins and the hairline. The pane stays
 * empty: the view brings its own skeleton, and a stand-in here would be a
 * second, different one. The rhythm is the shells' shared contract (8px top, 28px line,
 * 8px gap, 40px strip, 84px to the separator), so the real masthead lands on
 * the same pixels. One delayed gate for the whole shell: a cache-warm
 * revisit paints the real shell and never a bar.
 */
export function EntityShellSkeleton() {
  return (
    <SkeletonGroup className="flex min-h-0 min-w-0 flex-1 flex-col" data-slot="entity-shell-skeleton" aria-hidden>
      <Box gap="sm" paddingTop="sm" paddingX="md" shrink={false}>
        <Box direction="row" align="center" justify="between" gap="sm" minHeight={28}>
          <Box direction="row" align="center" gap="sm">
            <Skeleton width={16} height={16} className="rounded-[4px]" />
            <Skeleton height={14} width={128} />
          </Box>
          <Skeleton height={24} width={72} className="rounded-md" />
        </Box>
        <TabsStripSkeleton />
      </Box>
      <Separator />
    </SkeletonGroup>
  );
}
